<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item @click.native="handleBack">管理页面</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="height: 50px; padding-top: 10px">
      <el-button-group>
        <el-button class="healthButton" :class="{ healthActive: serviceIndex === index }" @click="clickService(index, item)" v-for="(item, index) in services" :key="index">{{ item.name }}</el-button>
      </el-button-group>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="page => onLoad(page, params)"
      :row-style="rowStyle"
      @cell-click="handleCellClick"
    >
      <template slot="menuLeft"></template>

      <template slot-scope="scope" slot="newDate">
        <el-button type="text" size="small" @click="toDataDetail(scope.row)">
          {{ scope.row.newDate }}
        </el-button>
      </template>

      <template slot="menu" slot-scope="{ row, index }">
        <el-button type="text" size="small" @click="toDataDetail(row, index)">查看详情</el-button>
        <el-button type="text" size="small" @click="removeUserFromService(row, index)">移除用户</el-button>
      </template>
    </avue-crud>

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%">
      <el-input v-model="inputValue" placeholder="请输入内容" clearable></el-input>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updateFlag">确认修改</el-button>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="pop_channel" :title="channel_title" width="50%">
      <el-select v-model="input_channel" placeholder="请选择" style="width: 100%; padding: 1vh 1 vw">
        <el-option v-for="item in channelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>

      <template #footer>
        <el-button @click="pop_channel = false">取消</el-button>
        <el-button type="primary" @click="updChannel">确认修改</el-button>
      </template>
    </el-dialog>
  </basic-container>
</template>

<script>
import { getUserAndDevice, view, updateFlag, getChannel, updChannel, removeUserFromService, getServiceDepartment } from '@/api/health/manage'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      channel: window.localStorage.getItem('channel'),
      username: window.localStorage.getItem('username'),
      fullscreenLoading: false,
      text: '',
      dialogVisible2: false,
      flagIndex: null,
      flagId: '',
      inputValue: '',
      dialogVisible: false,
      dialogTitle: '修改用户标签',
      pop_channel: false,
      input_channel: '',
      channel_title: '请选择用户渠道',
      params: {
        // channel: window.localStorage.getItem("channel"),
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      channelOptions: [],
      option: {
        tip: false,
        border: false,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        selection: true,
        cellEdit: true, // 启用单元格编辑
        menu: true,
        menuWidth: 190, // 初始宽度
        searchEnter: true,
        menuTitle: '处理与反馈',
        searchMenuSpan: 4,
        column: [
          {
            label: '用户ID',
            prop: 'name',
            search: true,
            width: 120,
            searchSpan: 4,
            searchValue: '', // 搜索值
            type: 'select', // 使用select组件，通常支持filterable
            // addDisplay: true,
            // editDisabled: false,
            dicUrl: 'https://dbadmin.dbzdjk.com/admin/manage/getName',
            dicQuery: {
              channel: window.localStorage.getItem('channel') === '大白主动健康' ? null : window.localStorage.getItem('channel')
            },
            dicMethod: 'get',
            props: {
              label: 'name',
              value: 'name'
            },
            filterable: true, // 启用过滤功能
            clearable: false, // 可清空
            placeholder: '请输入 姓名',
            slot: true,
            reserveKeyword: true // 关键：选择后保留关键字
          },
          {
            label: '性别',
            prop: 'sex',
            // search: true,
            type: 'select',
            dicData: [
              { label: ' ', value: 0 },
              { label: '男', value: 1 },
              { label: '女', value: 2 }
            ],
            width: 100
          },
          {
            label: '年龄',
            prop: 'age',
            width: 100
            // search: true,
          },
          {
            label: '联系方式',
            prop: 'mobile',
            search: true,
            width: 120,
            searchSpan: 4
          },
          // {
          //   label: "身份证",
          //   prop: "card",
          //   search: true,
          //   width: 150,
          // },
          {
            label: '会员级别',
            prop: 'vipLevel',
            type: 'select',
            search: true,
            dicData: [
              { label: '注册用户', value: 0 },
              // { label: "基础会员", value: 1 },
              { label: '体验会员', value: 2 },
              { label: '月度会员', value: 4 },
              { label: '季度会员', value: 5 },
              { label: '全年会员', value: 3 },
              { label: 'vip会员', value: 6 }
            ],
            width: 100,
            searchSpan: 4
          },
          {
            label: '注册时间',
            prop: 'createTime',
            formatter: row => row.createTime.substring(0, 16),
            width: 140,
            search: true,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            dateBtn: true, // 启用日期选择按钮
            align: 'center'
          },
          {
            label: '用户标签',
            prop: 'flag',
            edit: true,
            display: false,
            width: 120,
            overHidden: true
          },
          {
            label: '用户机构',
            prop: 'channel',
            // search: this.params.channel === "大白主动健康",
            search: true,
            type: 'select',
            dicData: [
              { label: '大白主动健康', value: '大白主动健康' },
              { label: '大白乐康', value: '大白乐康' },
              { label: '永诚保险', value: '永诚保险' },
              { label: '泰山社区卫生服务中心', value: '泰山社区卫生服务中心' },
              { label: '南钢集团', value: '南钢集团' }
            ],
            rules: [
              {
                required: true,
                message: '请输入渠道信息'
              }
            ],
            width: 170,
            searchSpan: 4
          },
          {
            label: '设备状态',
            prop: 'bind',
            type: 'select',
            dicData: [
              { label: '无设备', value: '0' },
              { label: '绑定状态', value: '1' }
            ],
            formatter: row => {
              if (row.bind === '1') {
                if (row.snType === '蓝牙') return `蓝牙设备`
                else return `${row.snType || ''}`
                // return `绑定状态 ${row.snType || ""}`;
              } else if (row.bind === '0') {
                return '无设备'
              }
              return row.bind
            }
          },
          {
            label: '最新健康数据时间',
            prop: 'newDate',
            width: 180
          },
          {
            label: '智能体类型',
            prop: 'ai',
            search: true,
            type: 'select',
            searchLabelWidth: 100,
            dicData: [
              { label: '大白星球', value: 1 },
              { label: '高血压数字药', value: 2 },
              { label: '减重智能体', value: 3 },
              { label: 'APP端', value: 4 },
              { label: ' ', value: 0 }
            ],
            searchSpan: 5
          }
        ]
      },
      data: [],
      services: [],
      serviceIndex: -1
    }
  },
  watch: {
    'option.column.0.searchValue'(newVal, oldVal) {
      console.log(`searchValue changed from ${oldVal} to ${newVal}`)
      // 在这里添加其他逻辑，例如更新UI等
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit
      }
    },
    ids() {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page }
    }
    sessionStorage.setItem('managementServiceAndUser', JSON.stringify(state))
    next()
  },
  methods: {
    onLoad(page, params) {
      const savedState = sessionStorage.getItem('managementServiceAndUser')
      if (savedState) {
        const state = JSON.parse(savedState)
        page = state.page
        params = state.params
        this.page = state.page
        this.params = state.params
        this.option.column[0].searchValue = params.name
        this.option.column[3].searchValue = params.mobile
        this.option.column[4].searchValue = params.vipLevel
        this.option.column[5].searchValue = params.createTime
        this.option.column[7].searchValue = params.channel
        this.option.column[10].searchValue = params.ai
        sessionStorage.removeItem('managementServiceAndUser')
      }

      getServiceDepartment('健管部', this.channel).then(res => {
        this.services = res.data
        if (this.serviceIndex === -1) this.serviceIndex = 0
        if (res.data.length > 0) {
          params.username = res.data[this.serviceIndex].name
          console.log(params.username)
          getUserAndDevice(page.currentPage, page.pageSize, params).then(res => {
            this.data = res.data.users
            this.page.total = res.data.total
          })
        }
      })
    },

    clickService(index, item) {
      this.serviceIndex = index
      this.page.currentPage = 1
      this.onLoad(this.page, this.params)
    },

    archiveType2(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/customer/latesthealthdata',
        query: parameter
      })
    },

    view(row, index) {
      view(row.wxUserId).then(res => {
        this.onLoad(this.page, this.params)
      })
    },

    handleBack() {
      // 如果有来源页面，则返回到来源页
      if (this.$route.query.from) {
        this.$router.push(this.$route.query.from)
      } else if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },

    rowStyle({ row, rowIndex }) {
      if (row.isNew === '0') {
        return {
          color: '#1890ff'
        }
      }
    },

    searchChange(params, done) {
      // params.channel = window.localStorage.getItem("channel");
      // console.log(params)
      this.params = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },

    searchReset() {
      this.params = {
        // channel: window.localStorage.getItem("channel"),
      }
      this.page.currentPage = 1
      this.onLoad(this.page, this.params)
    },

    selectionChange(list) {
      this.selectionList = list
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm)
    },

    datashow(row) {
      const parameter = {
        wxUserId: row.wxUserId
      }
      this.$router.push({
        path: '/customer/datashow',
        query: parameter
      })
    },

    handleCellClick(row, column, cell, event) {
      const key = column.columnKey
      if (key === 'flag') {
        this.dialogVisible = true
        this.inputValue = row.flag
        this.flagId = row.wxUserId
      }
      if (key === 'channel') {
        this.pop_channel = true
        this.input_channel = row.channel
        this.flagId = row.wxUserId
        getChannel().then(res => {
          this.channelOptions = res.data
        })
      }
    },

    updateFlag(row) {
      if (this.inputValue === '') {
        this.inputValue = ' '
      }
      updateFlag(this.flagId, this.inputValue).then(res => {
        this.dialogVisible = false
        if (res.success) {
          this.onLoad(this.page, this.params)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },

    updChannel(row) {
      this.pop_channel = false
      updChannel(this.flagId, this.input_channel).then(res => {
        this.onLoad(this.page, this.params)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      })
    },

    removeUserFromService(row, index) {
      const serviceAndUser = {
        wxUserId: row.wxUserId,
        pcUsername: this.services[this.serviceIndex].name
      }
      removeUserFromService(serviceAndUser).then(res => {
        if (res.success) {
          this.$message.success(res.msg)
          this.onLoad(this.page, this.params)
        }
      })
    },

    toDataDetail(row, index) {
      const parameter = {
        wxUserId: row.wxUserId,
        imei: row.sn,
        snType: row.snType
      }
      this.$router.push({
        path: '/customer/dataDetail',
        query: parameter
      })
    }
  }
}
</script>

<style scoped>
.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
  transform: skew(-10deg);
}

.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>
